import { LayersDictState } from '@/redux/layers/layers.types';
import { LayerLineAdapter } from '@/utils/layer/LayerLineAdapter';

export default function setLayerLine({
  layerId,
  layers,
  layerLine,
}: {
  layerId: number;
  layers: LayersDictState;
  layerLine: LayerLineAdapter;
}): void {
  const layer = layers[layerId];
  if (!layer) {
    return;
  }
  layer.lines[layerLine.getOriginalId()] = layerLine;
}
